import React from 'react';

/**
 * Hub page with navigation cards.
 * Props:
 *   title        — hub heading
 *   subtitle     — description
 *   cards        — [{ key, icon, label, desc, color? }]
 *   onNavigate   — (key) => void
 */
export default function HubPage({ title, subtitle, cards = [], onNavigate }) {
  return (
    <div style={{ padding: '24px 28px', maxWidth: 1400, margin: '0 auto' }}>
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: '#111827' }}>{title}</h1>
        {subtitle && <p style={{ margin: '6px 0 0', color: '#6B7280', fontSize: 14 }}>{subtitle}</p>}
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
        gap: 14,
      }}>
        {cards.map(c => {
          const Icon = c.icon;
          return (
            <div
              key={c.key}
              onClick={() => onNavigate && onNavigate(c.key)}
              style={{
                background: '#fff',
                border: '1px solid #E5E7EB',
                borderRadius: 10,
                padding: '16px 18px',
                cursor: 'pointer',
                transition: 'all 0.15s',
                display: 'flex',
                flexDirection: 'column',
                gap: 10,
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor = c.color || '#4F46E5';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.06)';
                e.currentTarget.style.transform = 'translateY(-1px)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor = '#E5E7EB';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              <div style={{
                width: 38, height: 38, borderRadius: 8,
                background: (c.color || '#4F46E5') + '15',
                color: c.color || '#4F46E5',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {Icon && <Icon size={20} strokeWidth={2.2}/>}
              </div>
              <div>
                <div style={{ fontSize: 15, fontWeight: 600, color: '#111827', marginBottom: 2 }}>{c.label}</div>
                {c.desc && <div style={{ fontSize: 12, color: '#6B7280', lineHeight: 1.4 }}>{c.desc}</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
